/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Pageable } from '../../models/pageable';
import { PagedModelProductMappingRequestModel } from '../../models/paged-model-product-mapping-request-model';

export interface GetProductMappingRequests$Params {
  merchantId?: string;
  innerId?: string;
  name?: string;
  productMappingId?: string;
  status?: 'NEW' | 'MAPPED' | 'DISABLED';
  pageable: Pageable;
}

export function getProductMappingRequests(http: HttpClient, rootUrl: string, params: GetProductMappingRequests$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelProductMappingRequestModel>> {
  const rb = new RequestBuilder(rootUrl, getProductMappingRequests.PATH, 'get');
  if (params) {
    rb.query('merchantId', params.merchantId, {});
    rb.query('innerId', params.innerId, {});
    rb.query('name', params.name, {});
    rb.query('productMappingId', params.productMappingId, {});
    rb.query('status', params.status, {});
    rb.query('pageable', params.pageable, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/problem+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedModelProductMappingRequestModel>;
    })
  );
}

getProductMappingRequests.PATH = '/product-mappings/requests';
